declare const CloudZoom;
export function cloudZoomDirective($timeout) {
    "ngInject"

    return {
        //replace: true,
        restrict: "C",
        //transclue: true,
        link: function (scope, elem, attrs) {

            $timeout(function () {
                CloudZoom.quickStart();
            }, 20);

        }
    };
}


// WEBPACK FOOTER //
// ./src/directives/cloudzoom/cloudzoom.ts